"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "zh": {
        "translation": {
            "global_navigation": {
                "navigation_items": {
                    "logo": "返回到启动面板",
                    "app_switcher": "切换应用",
                    "announcer": "公告",
                    "helper": "帮助和支持",
                    "user": "登录：{{username}}",
                    "user_with_customer": "{{username}} {{customerName}}",
                    "sign_in": "登录"
                },
                "apps": {
                    "academy": "学校",
                    "community": "社区",
                    "projects": "项目",
                    "results": "结果",
                    "storyboards": "Storyboard",
                    "mission_control": "任务控制",
                    "risks": "战略",
                    "reports": "报告",
                    "launchpad": "启动面板",
                    "robots": "机器人",
                    "frameworks": "框架",
                    "compliance_maps": "合规地图",
                    "assurance_plans": "保障计划",
                    "project_scheduler": "计划器",
                    "issue_tracker": "问题跟踪器",
                    "task_tracker": "任务跟踪器",
                    "project_timesheets": "时间表",
                    "dashboard": "{{module}}仪表盘",
                    "master_library": "主库"
                },
                "app_sections": {
                    "setup": "设置",
                    "workspace": "工作空间",
                    "automation": "自动化"
                },
                "user": {
                    "my_profile": "我的个人资料",
                    "log_out": "注销"
                },
                "helper": {
                    "help_docs": "帮助文档",
                    "support": "支持"
                },
                "skip_button": "跳到主要内容",
                "logo": "徽标",
                "other": "其他",
                "section": "部分"
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=zh.js.map